"use client";

/*eslint-disable */
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Sidebar from "./Sidebar";

interface ProductosComponentProps {
  categoriasData: any;
}

const ProductosComponent: React.FC<ProductosComponentProps> = ({
  categoriasData,
}) => {
  let currenPageProduct: any = localStorage.getItem("currenPageProduct");
  let currentPageCategory: any = localStorage.getItem("currentPageCategory")
  const [selectedCategory, setSelectedCategory] = useState<string>(
    currentPageCategory !== undefined && currentPageCategory !== null
      ? currentPageCategory
      : "Todas las categorías"
  );
  console.log(currenPageProduct);

  const [searchTerm, setSearchTerm] = useState<string>("");
  const [currentPage, setCurrentPage] = useState<number>(
    currenPageProduct !== undefined && currenPageProduct !== null
      ? parseInt(currenPageProduct)
      : 1
  );
  const itemsPerPage = 9;

  // Efecto para restablecer la página actual a 1 al cambiar de categoría o término de búsqueda
  useEffect(() => {
    if ((currenPageProduct !== undefined && currenPageProduct !== null) && (localStorage.getItem("back_products") !== undefined && localStorage.getItem("back_products") !== null )) {
      setCurrentPage(parseInt(currenPageProduct));
    } else {
      setCurrentPage(1);
      localStorage.setItem("currentPageCategory", selectedCategory)
      localStorage.setItem("currenPageProduct", "1");
    }

    setTimeout(() => {
      localStorage.removeItem("back_products")
    }, 100);
    //localStorage.removeItem("back_products")
  }, [selectedCategory, searchTerm]);

  const normalizeText = (text: any) => 
    text.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();

  // Función para filtrar los productos y eliminar duplicados
  // Función para filtrar los productos y eliminar duplicados
  const filteredProductos = categoriasData
    ?.flatMap((category: any) =>
      category.productos.filter((producto: any) =>
        normalizeText(producto.name).toLowerCase().includes(normalizeText(searchTerm))
      )
    )
    .filter(
      (producto: any) =>
        selectedCategory === "Todas las categorías" ||
        producto.categorias.includes(selectedCategory) // Asumiendo que cada producto tiene un array 'categories'
    )
    .sort((a: any, b: any) => a.name.localeCompare(b.name));

  // Eliminar duplicados
  const uniqueProductos = Array.from(
    new Map(filteredProductos.map((producto: any) => [producto.name, producto]))
  ).map(([, producto]) => producto);

  // Calcular el índice de los productos a mostrar
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = uniqueProductos.slice(indexOfFirstItem, indexOfLastItem);

  // Calcular el número total de páginas
  const totalPages = Math.ceil(uniqueProductos.length / itemsPerPage);

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
    localStorage.setItem("currenPageProduct", `${page}`);
  };

  return (
    <div className="blog-area ptb-100">
      <div className="container">
        <div className="row">
          <div className="col-xl-4 col-lg-5 col-md-12">
            <div className="left-sidebar">
              <Sidebar
                setSelectedCategory={setSelectedCategory}
                setSearchTerm={setSearchTerm}
                categoriasData={categoriasData}
                selectedCategory={selectedCategory}
              />
            </div>
          </div>

          <div className="col-xl-8 col-lg-7 col-md-12">
            <div className="row">
              {currentItems.length > 0 ? (
                currentItems.map((item: any, index: number) => (
                  <div
                    key={index}
                    className="col-xl-4 col-lg-6 col-md-4 mb-4"
                    data-aos="fade-up"
                    data-aos-duration="800"
                    data-aos-once="true"
                  >
                    <div className="single-blog-post">
                      <div className="image">
                        <Link to={`/producto/${item.slug}`} className="d-block">
                          <img
                            src={item?.name !== "Laboratorios" ? `/images/fotos/300x300/${item?.slug?.replace(/[^a-zA-Z0-9]/g, "-")}.webp` : "/images/laboratorios.webp"}
                            alt={item.name}
                            width={860}
                            height={545}
                            onError={(e) => { e.currentTarget.src = "/images/productos.webp"; }}
                          />
                        </Link>
                      </div>
                      <div className="content">
                        <h3>
                          <Link to={`/producto/${item.slug}`}>{item.name}</Link>
                        </h3>
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <div className="col-12">
                  <p>No hay productos disponibles en esta categoría.</p>
                </div>
              )}

              <div
                className="col-xl-12 col-lg-12 col-md-12"
                data-aos="fade-up"
                data-aos-duration="800"
                data-aos-once="true"
                data-aos-delay="300"
              >
                <div className="pagination-area">
                  <div className="nav-links">
                    {currentPage > 1 && (
                      <a
                        href="#"
                        className="prev page-numbers"
                        onClick={(e) => {
                          e.preventDefault();
                          handlePageChange(currentPage - 1);
                        }}
                      >
                        prev
                      </a>
                    )}
                    {Array.from({ length: totalPages }, (_, index) => (
                      <a
                        key={index}
                        href="#"
                        className={`page-numbers ${
                          currentPage === index + 1 ? "current" : ""
                        }`}
                        onClick={(e) => {
                          e.preventDefault();
                          handlePageChange(index + 1);
                        }}
                      >
                        {index + 1}
                      </a>
                    ))}
                    {currentPage < totalPages && (
                      <a
                        href="#"
                        className="next page-numbers"
                        onClick={(e) => {
                          e.preventDefault();
                          handlePageChange(currentPage + 1);
                        }}
                      >
                        next
                      </a>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductosComponent;
